<div class="flex items-center justify-between gap-2" #trigger="cdkOverlayOrigin" cdkOverlayOrigin>
  <div class="typo-h4-light flex h-10 items-center self-start text-text-tertiary">
    {{ 'schedule_details_appointment_reason' | translate }}
  </div>
  <div class="relative flex w-[250px] flex-col">
    <div
      #inputContainer
      class="flex min-h-10 w-full flex-wrap items-center gap-x-1 gap-y-[6px] rounded-2xl border bg-text-white px-3 py-2 text-text-primary focus-within:border-primary-blue"
      [ngClass]="{ 'border-states-red': isInvalidReason(), 'border-text-extra-light': !isInvalidReason() }"
    >
      @if (isReasonsDataLoading()) {
        <ng-lottie currentcolor class="h-4 w-4 text-primary-blue" [options]="lottieOptions"></ng-lottie>
      }
      @if (prefixIconSrc() && !isInputFocused() && !innerControl.value && !selectedItems()?.length) {
        <svg-icon [key]="prefixIconSrc()!" class="text-text-tertiary"></svg-icon>
      }

      @if (selectedItems()?.length) {
        @for (selectedItem of selectedItems(); track $index) {
          <div class="typo-h7-semibold flex items-center gap-1 rounded-md bg-background-light-grey px-2 py-[2px]">
            {{ selectedItem.abbreviation }}

            <button class="h-fit" (click)="deselectItem(selectedItem)">
              <svg-icon key="px-16-x" size="sm" class="text-text-tertiary"></svg-icon>
            </button>
          </div>
        }
      }

      <input
        #input
        #dropdownControl
        [formControl]="innerControl"
        class="typo-h4-light h-6 flex-1 border-0 bg-transparent leading-[22px] caret-primary-blue focus:outline-none"
        [placeholder]="selectedItems()?.length ? '' : ('schedule_details_appointment_reason_placeholder' | translate)"
        (focus)="onFocus()"
        (blur)="onBlur()"
      />
    </div>
    @if (isInvalidReason()) {
      <h6 class="typo-h7-light mt-[6px] ps-3 text-states-red">
        {{
          (!selectedItems()?.length ? 'schedule_details_no_appointment_reason' : 'schedule_details_invalid_appointment_reason') | translate
        }}
      </h6>
    }

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.offsetWidth"
      [cdkConnectedOverlayOrigin]="inputContainer"
      [cdkConnectedOverlayOpen]="dropdownOpen()"
      [cdkConnectedOverlayPositions]="overlayPositionStrategy"
      [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
      (overlayOutsideClick)="onOverlayOutsideClick($event)"
    >
      <div
        #dropdownList
        class="flex w-full flex-col gap-3 overflow-hidden rounded-[28px] border-2 border-background-white bg-background-modal shadow-card backdrop-blur"
      >
        <div
          #dropdownList
          class="flex w-full flex-col gap-3 overflow-hidden rounded-[28px] border-2 border-background-white bg-background-modal shadow-card backdrop-blur"
        >
          @if (!filteredItems() || (filteredItems() && !filteredItems()?.length)) {
            @if (isLoading()) {
              <div class="justify-centerp-4 flex items-center">
                <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
              </div>
            } @else {
              <div class="flex items-center justify-center p-4">
                <p class="typo-h7-semibold text-text-primary">{{ noResultLabelText() }}</p>
              </div>
            }
          } @else if (filteredItems()) {
            <cdk-virtual-scroll-viewport
              libDynamicVirtualViewportHeight
              [items]="filteredItems() ?? undefined"
              [itemSize]="53"
              [height]="dropdownHeight()"
              [style.max-height.px]="dropdownMaxHeight()"
              class="min-h-[53px]"
              minBufferPx="100"
              maxBufferPx="100"
            >
              @if (filteredItems(); as reasons) {
                <ng-container *cdkVirtualFor="let reason of reasons; let last = last">
                  <ng-template #reasonTooltip>
                    <div>
                      {{ reason.name }}
                    </div>
                  </ng-template>

                  <button
                    libInfiniteScrollListItem
                    class="flex h-10 gap-2 rounded-lg p-[2px] hover:bg-background-light-blue"
                    (click)="selectItem(reason)"
                    [disabled]="isItemSelected(reason)"
                  >
                    <p
                      class="typo-h5-semibold flex w-[50px] text-left"
                      [ngClass]="isItemSelected(reason) ? 'text-text-light' : 'text-primary-blue'"
                    >
                      {{ reason.code }}
                    </p>
                    <p
                      class="typo-h5-semibold flex w-[100px] text-left"
                      [ngClass]="isItemSelected(reason) ? 'text-text-light' : 'text-text-secondary'"
                    >
                      {{ reason.abbreviation }}
                    </p>
                    <p
                      class="typo-h5-book flex flex-1 text-left"
                      [ngClass]="isItemSelected(reason) ? 'text-text-light' : 'text-text-primary'"
                      [libUiTooltip]="reasonTooltip"
                      tooltipPosition="bottom"
                    >
                      <span class="line-clamp-2">{{ reason.name }}</span>
                    </p>
                  </button>

                  @if (!last) {
                    <div class="divider mb-2 mt-1 h-[1px] w-full bg-background-disabled"></div>
                  }
                </ng-container>

                @if (isLoading()) {
                  <div class="flex items-center justify-center p-4">
                    <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
                  </div>
                }
              }
            </cdk-virtual-scroll-viewport>
          }
        </div>
      </div>
    </ng-template>
  </div>
</div>
